<script>
  import { exactClass, link, settings } from "../../../core";
</script>

<div class="footer-logo">
  <a
    use:link
    href="/"
    use:exactClass={"active-logo"}
    aria-label={settings?.siteTitle || "logotype"}
  >
    <svg class="logo" width="233" height="28" aria-label="logotype">
      <use xlink:href="#logo-white" />
    </svg>
  </a>
</div>

<style>
  .logo {
    height: 28px;
  }

  .footer-logo {
    margin-bottom: 24px;
  }
</style>
